import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import Banner from '././components/banner.component'
import Title from '../../../../components/typography/title.component'
import PartnerList from '././components/partner-list.component'

class BuyWinPage extends React.Component {
	constructor(props) {
		super(props)
	}
	render() {
		return (
			<section>
				<Title>Compre e Ganhe</Title>
				<Banner />
				<PartnerList />
			</section>
		)
	}
}

const mapStateToProps = () => ({})
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)
const connectedBuyWinPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(BuyWinPage)
)

export { connectedBuyWinPage as ModuleRootComponent }
